import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class Team extends Component {
  state = {
    isEditMode: false,
    updatedTeam: {
      teamName: "",
      teamCode: "",
      teamOrganization: "",
      teamOrganizationName: "",
      id: "",
      kgCO2: 0,
      members: [],
    },
  };

  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.setState({ updatedTeam: this.props.team });
  }

  handleTeamEdit = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleEditSave = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateTeam(this.state.updatedTeam);
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      updatedTeam: {
        ...this.state.updatedTeam,
        [name]: value,
      },
    });
  }

  render() {
    return (
      <div className="tile is-child box notification">
        <Fragment>
          <a
            href="/"
            onClick={this.handleTeamEdit}
            className="product-edit-icon"
          >
            <FontAwesomeIcon icon="edit" />
          </a>
          <button
            onClick={(event) =>
              this.props.handleDeleteTeam(this.props.team.id, event)
            }
            className="delete"
          ></button>
        </Fragment>

        {this.state.isEditMode ? (
          <div>
            <p className="product-id">id: {this.props.team.id}</p>
            <p>Navn</p>
            <input
              className="input is-medium"
              type="text"
              name="teamName"
              value={this.state.updatedTeam.teamName}
              onChange={this.handleInputChange}
            />
            <p>Kode</p>
            <input
              className="input is-medium"
              type="text"
              name="teamCode"
              value={this.state.updatedTeam.teamCode}
              onChange={this.handleInputChange}
            />
            <button
              type="submit"
              className="button is-info is-small"
              onClick={this.handleEditSave}
            >
              Gem
            </button>
          </div>
        ) : (
          <div>
            <p className="product-title">{this.props.team.teamName}</p>
            <p className="product-id">
              <b>Medlemmer:</b> {this.props.team.members.length}
            </p>
            <p className="product-id">
              <b>Kode:</b> {this.props.team.teamCode}
            </p>
            <p className="product-id">
              <b>Organisation:</b> {this.props.organization}
            </p>
            <p className="product-id">
              <b>ID:</b> {this.props.team.id}
            </p>
            <p className="product-id">
              <b>Kampagne ID:</b> {this.props.team.campaignId}
            </p>
            <p className="product-id">
              <b>Point:</b> {this.props.team.points.totalPoints}
            </p>
            <p className="product-id">
              <b>Gns points:</b>{" "}
              {(
                this.props.team.points.totalPoints /
                this.props.team.members.length
              ).toFixed(2)}
            </p>
          </div>
        )}
      </div>
    );
  }
}
